module.exports = __webpack_public_path__ + "img/bg-login-employer.21e4a96b.jpg";